module.exports = __webpack_public_path__ + "static/media/plus.0fd04e2d.svg";